export default {"src":"/_next/static/media/senegal.d551d8eb.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};